import BifrostLogo from "../assets/images/partners/ic-bifrost-logo.svg";
import CplabsLogo from "../assets/images/partners/ic-cplabs-logo.svg";
import FbgLogo from "../assets/images/partners/ic-fbg-logo.svg";
import MblockLogo from "../assets/images/partners/ic-mblock-logo.svg";
import MetadiumLogo from "../assets/images/partners/ic-metadium-logo.svg";
import OntolgyLogo from "../assets/images/partners/ic-ontology-logo.png";
import RockxLogo from "../assets/images/partners/ic-rockx-logo.svg";
import SuperSchoolLogo from "../assets/images/partners/ic-superschool-logo.png";
import VeryWordsLogo from "../assets/images/partners/ic-verywords-logo.png";
import VistalabsLogo from "../assets/images/partners/ic-vistalabs-logo.svg";
export default {
  devmeta: [
    {
      logo: MetadiumLogo,
      company: "Metadium Technology, Inc.",
      link: "https://metadium.com/",
      addr: "0xa1e06EfeF74f6cdF5Ae5F1f8969Bfb937d40dC66",
      desc: "Metadium is an ecosystem built on a public identity blockchain designed to create a decentralized identity ecosystem with the real world introduction of Self-Sovereign Identity; the concept that individuals are owners of all aspects of their own identity in the offline and online world. Our vision is to create a free world through self-sovereign identity."
    },
    {
      logo: CplabsLogo,
      company: "CPLABS",
      link: "https://cplabs.io/",
      addr: "0xc6b6d06C24caDa80C4C1A17bE305EE2c28A8F15A",
      desc: "CPLABS is a leading South Korean blockchain development company. Since its founding in 2013, CPLABS has been providing next generation blockchain-based services and solutions to multiple industries, bringing innovation to people’s daily life. CPLABS is leading Korea’s blockchain industry with the biggest amount of blockchain"
    },
    {
      logo: OntolgyLogo,
      company: "Ontology",
      link: "https://ont.io/",
      addr: "0xd6caBbE11B3C680786f1F12259aa46640a60bb3D",
      desc: "Ontology is a project that provides trust, privacy, and security to Web3 through a distributed identity (DID) and data solution. Ontology builds an infrastructure that provides trusted access to the Web3, enabling individuals and businesses to have the confidence that users and their privacy come first with compliant digital identity solutions. In the future, Metadium and Ontology plan to collaborate with global DID councils such as W3C and DIF, jointly develop systems, develop DID framework that enables VCs interchangeable, and design DID standards for Korean/Chinese government projects through Mykeepin Alliance."
    },
    {
      logo: MblockLogo,
      company: "MBlock Inc.",
      link: "https://m-block.io/",
      addr: "0x42A6973E2DeA8252F257F91AcBD09A1E628Ff79C",
      desc: "Mblock is a blockchain, virtual asset, and NFT subsidiary company established by MAEKYUNG MEDIA GROUP. Mblock runs a validator business that supports operation of various blockchain networks such as Klaytn, Medibloc, and Metadium. And provides staking services for virtual assets. Mblock mints and builds various NFT projects, including World Knowledge Forum and Seoul Money Show. In addition, Mblock provides blockchain, virtual assets, NFT related content services such as newsletters."
    }
  ],
  production: [
    {
      logo: VeryWordsLogo,
      company: "VERYWORDS",
      link: "https://www.verywords.com/",
      addr: "0x880a74d68b09418136c4442D1eA0f5cC72E5325A", // METADIUM 것
      reward: "0x20b760fa17a984a225D8a7b9252A074133aE2253",
      desc: "Verywords operates a blockchain-based net-zero platform that supports verified carbon reduction activities. Through Metadium’s DID and NFT infrastructure, they have built a decentralized MRV system, enhanced IoT security and data reliability, and enabled a carbon credit reward mechanism. As a node partner, they plan to link blockchain to international carbon reduction initiatives."
    },
    {
      logo: SuperSchoolLogo,
      company: "SuperSchool",
      link: "https://superschool.kr/",
      addr: "0x880a74d68b09418136c4442D1eA0f5cC72E5325A", // METADIUM 것
      reward: "0x2Ef3D4CF5623FB1F0a6fA65217EbDA5986B48ad7",
      desc: "Superschool is an edtech company that operates a school administration management system and an online platform for student attendance and document records. To enhance the integrity and reliability of administrative information, Superschool integrates Metadium blockchain into its services. By joining as a node partner, the company aims to contribute to the expansion of blockchain-based educational certification ecosystems."
    },
    {
      logo: FbgLogo,
      company: "FBG Capital",
      link: "https://www.fbg.capital/",
      addr: "0x2Dc152f7c9CacDfFBfEfe5774Af1fDf14DF0C6F6",
      reward: "0x50C2bf20984B0Edb9072ff29d1A7175471413b4A",
      desc: "Founded in 2017, FBG Capital is an investment company dedicated to blockchain technology, and is a representative digital asset finance group that provides wealth management solutions using industry-leading expertise in research, product design, transaction execution, and risk management. FBG Capital will contribute to the establishment of Metadium's global partnership ecosystem."
    },
    {
      logo: MblockLogo,
      company: "MBlock Inc.",
      link: "https://m-block.io/",
      addr: "0xE7080384C22aA9B232993e2011b8c16585570524",
      reward: "0x1c57ea31aadec219e6e8e5aa3d315f2066e6ec1f",
      desc: "Mblock is a blockchain, virtual asset, and NFT subsidiary company established by MAEKYUNG MEDIA GROUP. Mblock runs a validator business that supports operation of various blockchain networks such as Klaytn, Medibloc, and Metadium. And provides staking services for virtual assets. Mblock mints and builds various NFT projects, including World Knowledge Forum and Seoul Money Show. In addition, Mblock provides blockchain, virtual assets, NFT related content services such as newsletters."
    },
    {
      logo: OntolgyLogo,
      company: "Ontology",
      link: "https://ont.io/",
      addr: "0xd8f5272EF21a50c5adB0fCEf31eb9E91aC4eB2f5",
      reward: "0x247c7D42849DBc977555676EF4Ac4F3796A740e2",
      desc: "Ontology is a project that provides trust, privacy, and security to Web3 through a distributed identity (DID) and data solution. Ontology builds an infrastructure that provides trusted access to the Web3, enabling individuals and businesses to have the confidence that users and their privacy come first with compliant digital identity solutions. In the future, Metadium and Ontology plan to collaborate with global DID councils such as W3C and DIF, jointly develop systems, develop DID framework that enables VCs interchangeable, and design DID standards for Korean/Chinese government projects through Mykeepin Alliance."
    },
    {
      logo: BifrostLogo,
      company: "Bifrost",
      link: "https://thebifrost.io/",
      addr: "0x6ce8328a6460D6Fe4c17fdbBF6fAA88120dD65B8",
      reward: "0x7b0896ef44c47D7CE71575520B89914f44Dfd98a",
      desc: "Bifrost is a middleware solution that provides an ecosystem for the simultaneous use of multiple blockchain protocols. BiFi is the first app to showcase the potential of Bifrost. It started the world's first native BTC lending service, and is currently providing services by linking Bitcoin, Ethereum, Binance Chain and Avalanche networks. Bifrost expects to create synergy and expand the ecosystem through Metadium's node operation."
    },
    {
      logo: VistalabsLogo,
      company: "VistaLabs Inc.",
      link: "https://www.vistalabs.info/",
      addr: "0xfb0A7D2536B9e42B627315c5BB938F1a6524f4E3",
      reward: "0x9341e09F288BFF513bB8a00b32F32600b65A03DB",
      desc: "VistaLabs is a crypto investment firm headquartered in Korea with 30+ portfolio projects globally. Established in 2021, the company has been investing in prominent blockchain projects in various sectors such as DeFi, P2E games, Metaverse, etc. The company is rapidly expanding its investments by leveraging the expertise from the crypto industry and traditional financial market."
    },
    {
      logo: RockxLogo,
      company: "RockX",
      link: "https://www.rockx.com/",
      addr: "0xa996EEFfe2d9d3CFFdCe5B7FC51C357DA7aBeA6D",
      reward: "0x9275cC6de34471f4a669e9dc0F90994Ad6702DA9",
      desc: "RockX is a leader in blockchain staking, leading the public blockchain. With a strong technical background and community driven operation, RockX provides secure validators to offer staking rewards for their cryptocurrency holders. RockX plans to build a Metadium staking pool in the future."
    },
    {
      logo: MetadiumLogo,
      company: "Metadium Technology, Inc.",
      link: "https://metadium.com/",
      addr: "0x880a74d68b09418136c4442D1eA0f5cC72E5325A",
      reward: "0x1180C92a0E50dCA73E666Da371F108A016be034f",
      desc: "Metadium is an ecosystem built on a public identity blockchain designed to create a decentralized identity ecosystem with the real world introduction of Self-Sovereign Identity; the concept that individuals are owners of all aspects of their own identity in the offline and online world. Our vision is to create a free world through self-sovereign identity."
    }
  ],
  testnet: [
    {
      logo: VeryWordsLogo,
      company: "VERYWORDS",
      link: "https://www.verywords.com/",
      addr: "0x880a74d68b09418136c4442D1eA0f5cC72E5325A", // METADIUM 것
      reward: "0x20b760fa17a984a225D8a7b9252A074133aE2253",
      desc: "Verywords operates a blockchain-based net-zero platform that supports verified carbon reduction activities. Through Metadium’s DID and NFT infrastructure, they have built a decentralized MRV system, enhanced IoT security and data reliability, and enabled a carbon credit reward mechanism. As a node partner, they plan to link blockchain to international carbon reduction initiatives."
    },
    {
      logo: SuperSchoolLogo,
      company: "SuperSchool",
      link: "https://superschool.kr/",
      addr: "0x880a74d68b09418136c4442D1eA0f5cC72E5325A", // METADIUM 것
      reward: "0x2Ef3D4CF5623FB1F0a6fA65217EbDA5986B48ad7",
      desc: "Superschool is an edtech company that operates a school administration management system and an online platform for student attendance and document records. To enhance the integrity and reliability of administrative information, Superschool integrates Metadium blockchain into its services. By joining as a node partner, the company aims to contribute to the expansion of blockchain-based educational certification ecosystems."
    },
    {
      logo: FbgLogo,
      company: "FBG Capital",
      link: "https://www.fbg.capital/",
      addr: "0x2Dc152f7c9CacDfFBfEfe5774Af1fDf14DF0C6F6",
      reward: "0x50C2bf20984B0Edb9072ff29d1A7175471413b4A",
      desc: "Founded in 2017, FBG Capital is an investment company dedicated to blockchain technology, and is a representative digital asset finance group that provides wealth management solutions using industry-leading expertise in research, product design, transaction execution, and risk management. FBG Capital will contribute to the establishment of Metadium's global partnership ecosystem."
    },
    {
      logo: MblockLogo,
      company: "MBlock Inc.",
      link: "https://m-block.io/",
      addr: "0xE7080384C22aA9B232993e2011b8c16585570524",
      reward: "0x1c57ea31aadec219e6e8e5aa3d315f2066e6ec1f",
      desc: "Mblock is a blockchain, virtual asset, and NFT subsidiary company established by MAEKYUNG MEDIA GROUP. Mblock runs a validator business that supports operation of various blockchain networks such as Klaytn, Medibloc, and Metadium. And provides staking services for virtual assets. Mblock mints and builds various NFT projects, including World Knowledge Forum and Seoul Money Show. In addition, Mblock provides blockchain, virtual assets, NFT related content services such as newsletters."
    },
    {
      logo: OntolgyLogo,
      company: "Ontology",
      link: "https://ont.io/",
      addr: "0xd8f5272EF21a50c5adB0fCEf31eb9E91aC4eB2f5",
      reward: "0x247c7D42849DBc977555676EF4Ac4F3796A740e2",
      desc: "Ontology is a project that provides trust, privacy, and security to Web3 through a distributed identity (DID) and data solution. Ontology builds an infrastructure that provides trusted access to the Web3, enabling individuals and businesses to have the confidence that users and their privacy come first with compliant digital identity solutions. In the future, Metadium and Ontology plan to collaborate with global DID councils such as W3C and DIF, jointly develop systems, develop DID framework that enables VCs interchangeable, and design DID standards for Korean/Chinese government projects through Mykeepin Alliance."
    },
    {
      logo: BifrostLogo,
      company: "Bifrost",
      link: "https://thebifrost.io/",
      addr: "0x6ce8328a6460D6Fe4c17fdbBF6fAA88120dD65B8",
      reward: "0x7b0896ef44c47D7CE71575520B89914f44Dfd98a",
      desc: "Bifrost is a middleware solution that provides an ecosystem for the simultaneous use of multiple blockchain protocols. BiFi is the first app to showcase the potential of Bifrost. It started the world's first native BTC lending service, and is currently providing services by linking Bitcoin, Ethereum, Binance Chain and Avalanche networks. Bifrost expects to create synergy and expand the ecosystem through Metadium's node operation."
    },
    {
      logo: VistalabsLogo,
      company: "VistaLabs Inc.",
      link: "https://www.vistalabs.info/",
      addr: "0xfb0A7D2536B9e42B627315c5BB938F1a6524f4E3",
      reward: "0x9341e09F288BFF513bB8a00b32F32600b65A03DB",
      desc: "VistaLabs is a crypto investment firm headquartered in Korea with 30+ portfolio projects globally. Established in 2021, the company has been investing in prominent blockchain projects in various sectors such as DeFi, P2E games, Metaverse, etc. The company is rapidly expanding its investments by leveraging the expertise from the crypto industry and traditional financial market."
    },
    {
      logo: RockxLogo,
      company: "RockX",
      link: "https://www.rockx.com/",
      addr: "0xa996EEFfe2d9d3CFFdCe5B7FC51C357DA7aBeA6D",
      reward: "0x9275cC6de34471f4a669e9dc0F90994Ad6702DA9",
      desc: "RockX is a leader in blockchain staking, leading the public blockchain. With a strong technical background and community driven operation, RockX provides secure validators to offer staking rewards for their cryptocurrency holders. RockX plans to build a Metadium staking pool in the future."
    },
    {
      logo: MetadiumLogo,
      company: "Metadium Technology, Inc.",
      link: "https://metadium.com/",
      addr: "0x880a74d68b09418136c4442D1eA0f5cC72E5325A",
      reward: "0x1180C92a0E50dCA73E666Da371F108A016be034f",
      desc: "Metadium is an ecosystem built on a public identity blockchain designed to create a decentralized identity ecosystem with the real world introduction of Self-Sovereign Identity; the concept that individuals are owners of all aspects of their own identity in the offline and online world. Our vision is to create a free world through self-sovereign identity."
    }
  ]
};
